import { css } from '@/styled-system/css';

export const calendarBodyStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  rowGap: 'Calendar.Body.gap.header-toDays',
  borderSpacing: 0,
});

export const calendarBodyHeaderStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
});

export const calendarBodyGridStyles = css.raw({
  paddingInline: 'Calendar.Body.padding.horz',
  display: 'grid',
  rowGap: 'Calendar.Day.margin.vert',
});

export const calendarBodyGridRowStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  columnGap: 'Calendar.Day.margin.horz',
  rowGap: 'Calendar.Day.margin.vert',
  minHeight: 'Calendar.Day.height',
});
